import { NgModule } from '@angular/core';
import { MaterialListModule } from './material-list/material-list.module';
import { MaterialFormModule } from './materail-form/material-form.module';
import { MaterialWidgetModule } from './material-widget/material-widget.module';
import { MaterialNewModule } from './material-new/material-new.module';
import { MaterialCatalogListModule } from './material-catalog-list/material-catalog-list.module';
import { MaterialEditModule } from './material-edit/material-edit.module';

@NgModule({
  declarations: [],
  imports: [
    MaterialListModule,
    MaterialFormModule,
    MaterialWidgetModule,
    MaterialNewModule,
    MaterialCatalogListModule,
    MaterialEditModule,
  ],
  exports: [],
  providers: [],
})
export class MaterialModule {}
